import storeIcon from 'assets/img/storeIcon.png'
import { Link, useSearchParams } from 'react-router-dom'
import Payment from './Payment/Payment';
import { ApiRequest } from 'GlobalFunctions';
import { useEffect, useState } from 'react';
import { PiArrowLeftLight } from "react-icons/pi";
import { PiXCircleLight } from "react-icons/pi";


export default function StoreTransfer () {
    const [searchParams] = useSearchParams();
    const transfer_code = searchParams.get('tid') || '';
    const [info, setInfo] = useState<any | null>(null);
    const [error, setError] = useState(false)

    const getStoreInfo = async () => {
        await ApiRequest({
            url: '/stores/getStoreTransferInfo',
            method: 'GET',
            query: {
                transfer_code
            },
            setResponse: (response: any) => {
                if (response.status == "success") {
                    setInfo(response.data);
                } else {
                    setError(true);
                }
            }
        });
    };
    
    useEffect(() => {
        getStoreInfo();
    }, []);


    console.log("TRANSFER CODE ",transfer_code);
    return (
            error ? (
                <div className="store-transfer-container">
                    <div className="store-transfer-bc">
                        <Link to="/account" replace className='store-transfer-back-link'>
                            <PiArrowLeftLight />
                            Back
                        </Link>
                    </div>
                    <div className="store-transfer-error">
                        <PiXCircleLight size={18} color="#BD2427" />
                        <span>You have no pending requests. Previous requests may have been canceled or expired.</span>
                    </div>
                </div>
            ) : (

            <div className="store-transfer-container">
                <div className="store-transfer-bc">
                    <Link to="/account" replace className='store-transfer-back-link'>
                        <PiArrowLeftLight />
                        Accept site transfer
                    </Link>
                </div>

                <div className="store-transfer-header">
                    <img src={storeIcon} className="store-transfer-icon" alt="Store transfer icon" />
                    <div className="store-transfer-title">
                        <h2>{info ? `${info.company_email} - ${info.store_name}` : 'Loading...'}</h2>
                        <span className="store-transfer-subtitle">{info ? `${info.company_email} is sending you the store "${info.store_name}". The request to transfer ${info.store_name} from ${info.company_email} will remain valid for 7 days.` : 'Loading store information...'}</span>
                    </div>
                </div>
                <Payment style="account" transfer_code={transfer_code} />
            </div>
        )
    )
}